<template>Redirecting..</template>

<script lang="ts" setup>
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const orderedKeys = [
    "artefactId",
    "taskId",
    "processId",
    "domainId",
    "productId",
    "stekId",
    "organizationId",
];

// Check if there are 'id' params in the route. E.g. artefactId, taskId, processId, etc.
const keys = Object.entries(route.params)
    .filter(([key, value]) => key.endsWith("Id") && value)
    .sort((a, b) => orderedKeys.indexOf(a[0]) - orderedKeys.indexOf(b[0]));

// Should never happen, just being defensive.
if (!keys) {
    // Couldn't find anything, so lets just redirect to a 'not found' page.
    router.push({
        name: "not-found",
        params: {
            orgName: route.params.orgName,
            stekName: route.params.stekName,
        },
        query: {
            type: "unknown",
        },
    });
}

const lastKey = keys[0][0];
const lastValue = keys[0][1];

let page = keys[0][0].replace(/Id$/, "Page");

// Artefacts are a special case, for the user they are mostly like documents.
if (page === "artefactPage") {
    page = "documentPage";
}

router.push({
    name: page,
    params: {
        orgName: route.params.orgName,
        stekName: route.params.stekName,
        [lastKey]: lastValue,
    },
});
</script>

<style></style>
